/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import appConfig from '../stores/config';

const downloadErrorAnalytics = () => {
    const analyticsObj = {
        event: {
            workflow: 'Apps',
            type: 'render',
            subcategory: 'Apps Loader:Load',
            subtype: 'error',
            error_type: 'download-error',
        },
        content: {
            category: 'desktop',
        },
    };
    appConfig.analyticsCallback({ analyticObjectList: [analyticsObj] });
};

export { downloadErrorAnalytics };
